// extracted by mini-css-extract-plugin
export default {"root":"ActionButtonWithPrompt_root__PWGX3","placeHolderShimmer":"ActionButtonWithPrompt_placeHolderShimmer__NMM7a"};